import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, MessageCircle } from 'lucide-react';

/**
 * Floating Action Buttons for quick navigation within the Weddings section.
 * Displays Dashboard and Messages shortcuts.
 */
export default function WeddingNavFabs() {
    const navigate = useNavigate();
    const location = useLocation();

    // Check which page is active
    const isMessagesActive = location.pathname === '/weddings/messages';
    const isDashboardActive = location.pathname.startsWith('/vendor/');

    return (
        <div className="fixed bottom-6 left-6 z-40 flex flex-col gap-3">
            {/* Dashboard FAB */}
            <button
                onClick={() => navigate('/vendor/dashboard')}
                className={`group flex items-center gap-2 px-4 py-3 rounded-full shadow-lg transition-all duration-300 ${isDashboardActive
                        ? 'bg-rose-600 text-white'
                        : 'bg-white dark:bg-zinc-800 text-gray-700 dark:text-gray-200 hover:bg-rose-50 dark:hover:bg-zinc-700 border border-gray-200 dark:border-zinc-700'
                    }`}
                title="Vendor Dashboard"
            >
                <LayoutDashboard size={20} />
                <span className="text-sm font-medium hidden md:inline">Dashboard</span>
            </button>

            {/* Messages FAB */}
            <button
                onClick={() => navigate('/weddings/messages')}
                className={`group flex items-center gap-2 px-4 py-3 rounded-full shadow-lg transition-all duration-300 ${isMessagesActive
                        ? 'bg-rose-600 text-white'
                        : 'bg-white dark:bg-zinc-800 text-gray-700 dark:text-gray-200 hover:bg-rose-50 dark:hover:bg-zinc-700 border border-gray-200 dark:border-zinc-700'
                    }`}
                title="Messages"
            >
                <MessageCircle size={20} />
                <span className="text-sm font-medium hidden md:inline">Messages</span>
            </button>
        </div>
    );
}
